import { render, staticRenderFns } from "./PreciseRiskFactorNumber.vue?vue&type=template&id=2d1f82b6&"
import script from "./PreciseRiskFactorNumber.vue?vue&type=script&lang=js&"
export * from "./PreciseRiskFactorNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports